import React from "react";
import { Field } from "redux-form";

const format = value => {
  if (!value) {
    return "";
  }

  let newValue = value.replace(/\D/g, "").match(/(\d{0,4})(\d{0,2})(\d{0,4})/);

  newValue = !newValue[2]
    ? newValue[1]
    : `${newValue[1]}.${newValue[2]}${`${newValue[3]
        ? `.${newValue[3]}`
        : ""}`}`;

  return newValue;
};

export default function ScheduleBOrHTCodeField(props) {
  const { ...rest } = props;

  return <Field type="text" format={format} {...rest} />;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/ScheduleBOrHTCodeField/ScheduleBOrHTCodeField.jsx